import styled from '@emotion/styled';

export const StyledMobileContainer = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  gap: 16px;
`;
